import { initializeApp } from "@firebase/app";
import config from "./config";

export default class Firebase
{
    constructor()
    {
        initializeApp(config.firebase);
    }
}